__turbopack_context__.v({
  "ctaBtn": "ParagraphDarkHeroCta-module__yedW9a__ctaBtn",
  "eyebrow": "ParagraphDarkHeroCta-module__yedW9a__eyebrow",
  "inner": "ParagraphDarkHeroCta-module__yedW9a__inner",
  "lead": "ParagraphDarkHeroCta-module__yedW9a__lead",
  "section": "ParagraphDarkHeroCta-module__yedW9a__section",
  "title": "ParagraphDarkHeroCta-module__yedW9a__title",
});
